import { render, staticRenderFns } from "./imagePreviewForAttachment.vue?vue&type=template&id=6d37ddcf&scoped=true"
import script from "./imagePreviewForAttachment.vue?vue&type=script&lang=js"
export * from "./imagePreviewForAttachment.vue?vue&type=script&lang=js"
import style0 from "./imagePreviewForAttachment.vue?vue&type=style&index=0&id=6d37ddcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8d78c4fc2b2e880cb3796fb82bca3a94/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d37ddcf",
  null
  
)

export default component.exports